module.exports = __webpack_public_path__ + "media/icons/message@2x-a3001191.png";